module.exports = __webpack_public_path__ + "img/cloth_g3_hat-12.4dad233a.svg";